"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./TimeBasedList.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _renderDownloadIcon = _interopRequireDefault(require("../../utils/renderDownloadIcon"));
var _trimbleGlobe = _interopRequireDefault(require("../../images/trimble-globe.jpg"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Card = _ref => {
  let {
    title,
    date,
    endDate,
    category,
    url,
    description,
    formats,
    image,
    variant,
    Link
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "group info-group"
  }, variant === "short-details" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (title || category) && /*#__PURE__*/_react.default.createElement("div", {
    className: "details"
  }, category && /*#__PURE__*/_react.default.createElement("div", {
    className: "industry-category"
  }, category), title && url ? /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: url,
    Link: Link && Link,
    className: (0, _checkForExternalLink.default)(url) ? "title-external" : "title",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(title)
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "title",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(title)
  })), date && /*#__PURE__*/_react.default.createElement("div", {
    className: "date",
    "aria-label": `${date?.month} ${date?.day}, ${date.year}${endDate ? ` to ${endDate?.month} ${endDate?.day}, ${endDate.year}` : ""}`
  }, `${date?.month} ${date?.day}, ${date.year}${endDate ? ` - ${endDate?.month} ${endDate?.day}, ${endDate.year}` : ""}`)), variant === "long-details" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "thumbnail-container"
  }, !image?.focalPointImage?.url && /*#__PURE__*/_react.default.createElement("img", {
    className: "desktop",
    src: image?.desktop?.url || _trimbleGlobe.default,
    alt: image?.desktop?.alt || "Trimble Logo"
  }), image?.focalPointImage?.url && /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    imageSizes: {
      desktop: {
        width: 200,
        height: 180,
        ratio: {
          width: 10,
          height: 9
        }
      },
      tablet: {
        width: 200,
        height: 180,
        ratio: {
          width: 10,
          height: 9
        }
      },
      mobile: {
        width: 300,
        height: 180,
        ratio: {
          width: 5,
          height: 3
        }
      }
    },
    focalPointImage: image?.focalPointImage || _trimbleGlobe.default,
    alt: (0, _generateFocusedImageAlt.default)(image)
  })), (category || date || title || description) && /*#__PURE__*/_react.default.createElement("div", {
    className: "details"
  }, category && /*#__PURE__*/_react.default.createElement("div", {
    className: "industry-category"
  }, category), date && /*#__PURE__*/_react.default.createElement("div", {
    className: "date",
    "aria-label": `${date?.month} ${date?.day}, ${date.year}${endDate ? ` to ${endDate?.month} ${endDate?.day}, ${endDate.year}` : ""}`
  }, `${date?.month} ${date?.day}, ${date.year}${endDate ? ` - ${endDate?.month} ${endDate?.day}, ${endDate.year}` : ""}`), title && url ? /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: url,
    Link: Link && Link,
    className: "title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(title)
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "title",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(title)
  }), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "description"
  }, /*#__PURE__*/_react.default.createElement("p", null, description)), formats?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "group docs"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Downloads:\xA0"), formats?.length > 1 ? formats?.map((format, index) => format.url && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `format-${index}`
  }, /*#__PURE__*/_react.default.createElement("a", {
    "aria-label": `Download ${format?.type === "pdf" ? "pdf" : "text"} version of ${format?.description ? format.description : format.url}`,
    target: "_blank",
    className: "link",
    href: format.url
  }, format?.type === "pdf" ? "PDF" : "Text"), (0, _renderDownloadIcon.default)("#0063a3"), index < formats.length - 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0"))) : formats?.[0]?.url && /*#__PURE__*/_react.default.createElement("a", {
    "aria-label": `Download ${formats?.[0]?.type === "pdf" ? "pdf" : "text"} version of ${formats?.[0]?.description ? formats?.[0].description : formats?.[0].url}`,
    target: "_blank",
    className: "link",
    href: formats[0].url
  }, formats[0]?.type === "pdf" ? "PDF" : "Text"))))), formats?.length && variant == "short-details" && /*#__PURE__*/_react.default.createElement("div", {
    className: "group docs"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Downloads:\xA0"), formats?.length > 1 ? formats?.map((format, index) => format.url && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `format-${index}`
  }, /*#__PURE__*/_react.default.createElement("a", {
    "aria-label": `Download ${format?.type === "pdf" ? "pdf" : "text"} version of ${format?.description ? format.description : format.url}`,
    className: "link",
    target: "_blank",
    href: format.url
  }, format?.type === "pdf" ? "PDF" : "Text"), (0, _renderDownloadIcon.default)("#0063a3"), index < formats.length - 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0"))) : formats?.[0]?.url && /*#__PURE__*/_react.default.createElement("a", {
    "aria-label": `Download ${formats?.[0]?.type === "pdf" ? "pdf" : "text"} version of ${formats?.[0]?.description ? formats?.[0].description : formats?.[0].url}`,
    className: "link",
    target: "_blank",
    href: formats[0].url
  }, formats[0]?.type === "pdf" ? "PDF" : "Text")));
};
const Group = _ref2 => {
  let {
    title,
    entries,
    variant
  } = _ref2;
  entries.map(entry => Object.assign(entry, {
    startDate: new Date(entry.date.raw)
  }));
  let sortedEntries = entries.sort((a, b) => b.startDate - a.startDate);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `card-group ${variant}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "heading"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-headings"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "col-heading summary"
  }, "Event/Article/Summary"), variant === "short-details" && /*#__PURE__*/_react.default.createElement("span", {
    className: "col-heading dates"
  }, "Date"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "cards"
  }, sortedEntries?.length && sortedEntries?.length > 1 ? sortedEntries.map((entry, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `${entry?.title}-${index}`
  }, /*#__PURE__*/_react.default.createElement(Card, {
    title: entry?.title,
    date: entry?.date,
    endDate: entry?.endDate,
    category: entry?.category,
    url: entry?.url,
    description: entry?.description,
    formats: entry?.formats,
    image: entry?.image,
    variant: variant
  }))) : /*#__PURE__*/_react.default.createElement(Card, {
    title: entries?.[0]?.title,
    date: entries?.[0]?.date,
    endDate: entries?.[0]?.endDate,
    category: entries?.[0]?.category,
    url: entries?.[0]?.url,
    description: entries?.[0]?.description,
    formats: entries?.[0]?.formats,
    image: entries?.[0]?.image,
    variant: variant
  })));
};
const TimeBasedList = _ref3 => {
  let {
    groups,
    variant
  } = _ref3;
  return groups ? /*#__PURE__*/_react.default.createElement("div", {
    className: "time-based-list-container"
  }, groups.map(group => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: group?.key
  }, /*#__PURE__*/_react.default.createElement(Group, {
    title: group?.title,
    entries: group?.entries,
    variant: variant
  })))) : null;
};
var _default = TimeBasedList;
exports.default = _default;